import { useEffect, useMemo, useState } from "react";
import RelativeTime from "dayjs/plugin/relativeTime";
import dayjs from "dayjs";

dayjs.extend(RelativeTime);

const CREATED_DATE_KEYS = [
  "createdAt",
  "created_at",
  "createdOn",
  "createdDate",
  "dateCreated",
  "creationDate",
  "_createdAt",
];

const normalizeTimestamp = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    const timestamp = value.getTime();
    return Number.isFinite(timestamp) ? timestamp : null;
  }

  if (typeof value === "number") {
    if (!Number.isFinite(value)) return null;
    return Math.abs(value) < 1000000000000 ? value * 1000 : value;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;

    if (/^-?\d+(\.\d+)?$/.test(trimmed)) {
      return normalizeTimestamp(Number(trimmed));
    }

    const timestamp = new Date(trimmed).getTime();
    return Number.isFinite(timestamp) ? timestamp : null;
  }

  return null;
};

export const getListCreatedTimestamp = (list) => {
  if (!list || typeof list !== "object") return null;

  for (const key of CREATED_DATE_KEYS) {
    const timestamp = normalizeTimestamp(list[key]);
    if (timestamp != null) return timestamp;
  }

  return null;
};

export const formatListCreatedRelativeTime = (list) => {
  const timestamp = getListCreatedTimestamp(list);
  if (timestamp == null) return "";

  return dayjs(timestamp).fromNow();
};

export const useListCreatedRelativeTime = (list) => {
  const timestamp = useMemo(() => getListCreatedTimestamp(list), [list]);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (timestamp == null) return undefined;

    setNow(Date.now());
    const intervalId = window.setInterval(() => {
      setNow(Date.now());
    }, 15000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [timestamp]);

  if (timestamp == null) return "";

  return dayjs(timestamp).from(dayjs(now));
};
